<template>
  <div>
    <v-form ref="form" class="contact-form">
      <v-text-field
        :rules="rules.name"
        name="name"
        label="Nome"
        required
        outlined
        dense
      ></v-text-field>
      <v-text-field
        :rules="rules.email"
        name="email"
        label="E-mail"
        required
        outlined
        dense
      ></v-text-field>
      <v-text-field
        :rules="rules.tel"
        name="tel"
        label="Telefone"
        required
        v-mask="['(##) ####-####', '(##) #####-####']"
        outlined
        dense
      ></v-text-field>
      <v-textarea
        :rules="rules.message"
        :counter="300"
        name="message"
        label="Mensagem"
        required
        outlined
        dense
      ></v-textarea>
      <v-checkbox
        name="policy_privacy"
        :rules="[(v) => !!v || 'Você precisa aceitar para continuar.']"
        required
        value="1"
        on-icon="fa fa-check-square"
        off-icon="far fa-square"
        class="policy-privacy"
      >
        <template v-slot:label>
          <div>
            Eu li e concordo com a
            <a @click="showPrivacy">Política de Privacidade</a>.
          </div>
        </template>
      </v-checkbox>

      <v-btn
        @click="submit"
        color="secondary lighten-2"
        class="py-4 px-12"
        tile
        depressed
      >
        ENVIAR
      </v-btn>
    </v-form>
    <v-overlay v-model="loading">
      <Loading />
    </v-overlay>
    <v-snackbar
      v-model="snackbarOpen"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      centered
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          @click="snackbarOpen = false"
          color="white"
          text
          icon
          small
        >
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import Loading from "@/components/widgets/Loading.vue";
import { name, email, tel, message } from "./rules";

export default {
  data: () => ({
    loading: false,
    snackbarOpen: false,
    snackbarText: "Lorem Ipsum",
    snackbarColor: "Grey",
    snackbarTimeout: 3000,
    rules: {
      name,
      email,
      tel,
      message,
    },
  }),
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
    submit() {
      const form = this.$refs.form;

      if (form.validate()) {
        this.loading = true;

        const formData = new FormData(form.$el);
        const action = `${this.server}/rest/email/contact-us`;

        fetch(action, {
          method: "POST",
          body: formData,
        })
          .then((r) => {
            if (r.ok) {
              this.snackbarText = "Mensagem enviada com sucesso.";
              this.snackbarColor = "green";
              this.snackbarOpen = true;

              form.reset();
              form.resetValidation();
            } else {
              throw new Error();
            }
          })
          .catch(() => {
            this.snackbarText =
              "Não foi possível enviar a mensagem. Tente novamente mais tarde";
            this.snackbarColor = "red";
            this.snackbarOpen = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  directives: {
    mask,
  },
  components: {
    Loading,
  },
};
</script>

<style>
.contact-form {
  display: grid;
  gap: 0px 16px;
  grid-template-columns: 1fr 1fr;
  max-width: 500px;
}
.contact-form > :nth-child(1),
.contact-form > :nth-child(4),
.contact-form > :nth-child(5),
.contact-form > :nth-child(6) {
  grid-column-end: span 2;
}
</style>
